/// <reference path="../../../typings/index.d.ts" />
module Meevo {

  export interface IContextParams {
      params: any;
      addInteropParams(interopParams: any): void;
  }

  export class ContextParamsService implements IContextParams {

    public params: angular.ui.IStateParamsService;

    constructor() {

    }

    static factory(): Function {
      let svc = () => {
        return new ContextParamsService();
      }
      svc.$inject = [];
      return svc;
    }

    addInteropParams(interopParams: any): void {
      if (!this.params) {
        this.params = {};
      }
      this.params.interopParams = { ...interopParams };
    }

  }

  angular.module("meevo")
    .factory("meevo.ContextParams", ContextParamsService.factory());

}